<template>
  <div class="container text-center">
    <h1>404</h1>
    <p>Uh oh! We couldn't find the page you were looking for!</p>
  </div>
</template>

<script>
export default {
  name: '404',
};
</script>
